import React, { useState } from "react";
import styles from "./Location.module.scss";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Create from "@material-ui/icons/Create";

export const LocationList = ({
  props,
  locationList,
  deleteActionHandler,
}) => {
  return (
    <>
      {locationList.map((el, i) => (
        <div key={"loc-" + i} className={`${styles.editSection}`}>
          <>
            <div className={"row"}>
              <div className={"col-3"}>
                <label>Tenure Type</label>
              </div>
              <div className={"col-7 " + styles.divContent}>
                {el.tenureType.value}
              </div>
              <div className={"col-2 " + styles.editButtonSection}>
                <Create
                  onClick={() => {
                    props.history.push(`./location/detail/${i}`);
                  }}
                />
                <DeleteOutline
                  onClick={() => {
                    deleteActionHandler(i);
                  }}
                />
              </div>
            </div>
            {el.lga.value && (
              <div className={"row"}>
                <div className={"col-3"}>
                  <label>LGA</label>
                </div>
                <div className={"col-7 " + styles.divContent}>
                  {el.lga.value}
                </div>
              </div>
            )}
            {el.lls.value && (
              <div className={"row"}>
                <div className={"col-3"}>
                  <label>LLS</label>
                </div>
                <div className={"col-7 " + styles.divContent}>
                  {el.lls.value}
                </div>
              </div>
            )}
            {el.karstArea.value && (
              <div className={"row"}>
                <div className={"col-3"}>
                  <label>Karst Area</label>
                </div>
                <div className={"col-7 " + styles.divContent}>
                  {el.karstArea.value}
                </div>
              </div>
            )}
            {el.marinePark.value && (
              <div className={"row"}>
                <div className={"col-3"}>
                  <label>Marine Park</label>
                </div>
                <div className={"col-7 " + styles.divContent}>
                  {el.marinePark.value}
                </div>
              </div>
            )}
            {el.stateForest.value && (
              <div className={"row"}>
                <div className={"col-3"}>
                  <label>State Forests</label>
                </div>
                <div className={"col-7 " + styles.divContent}>
                  {el.stateForest.value}
                </div>
              </div>
            )}
            {el.locationSearch.value && (
              <div className={"row"}>
                <div className={"col-3"}>
                  <label>Branch / Region / Area / Park</label>
                </div>
                <div className={"col-7 " + styles.divContent}>
                  {el.locationSearch.value}
                </div>
              </div>
            )}
            {el.other && (
              <div className={"row"}>
                <div className={"col-3"}>
                  <label>Other</label>
                </div>
                <div className={"col-7 " + styles.divContent}>{el.other}</div>
              </div>
            )}
          </>
        </div>
      ))}
    </>
  );
};

export default LocationList;
